import s from './remove-appointments-note.module.scss'
import { Modal } from '@shared/ui/modal/modal';
import { Button } from '@shared/ui/button/button';
import { useRemoveAppointmentsNoteModal } from '../../model/use-remove-appointments-note-modal';
import { useRemoveAppointmentNote } from '../../api/useRemoveAppointmentNote';

export const RemoveAppointmentsNoteModal = () => {
	const {isOpen, close, modalParams} = useRemoveAppointmentsNoteModal()
	
	const appointmentId = modalParams?.appointmentId
	const noteId = modalParams?.noteId

	const {mutate: remove} = useRemoveAppointmentNote(appointmentId)
	
	const removeNote = () => {
		remove({appointmentId, noteId})
		close()
	}

  return (
		<Modal {...{isOpen, close}}>
			<div className={s.card}>
					<div className={s.title}>Вы уверены?</div>
					<div className={s.text}>Вы точно хотете удалить заметку?</div>
					<div className={s.btns}>
						<Button
							theme='secondary'
							className={s.btn}
							onClick={() => close()}
							label={'Нет'}
						/>
						<Button
							className={s.btn}
							onClick={removeNote}
							label={'Да'}
						/>
					</div>
			</div>
		</Modal>
  );
};